import { Group, Image, Stack, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import ImagePlaceholder from '@/assets/image-placeholder.png'
import { OnlineStatus } from '@/components/devices/OnlineStatus/OnlineStatus'
import { Camera } from '@/types/camera'

type CameraCellProps = {
  camera: Camera | null
  deviceActive: boolean
  fallbackName?: string
}

export const CameraCell = ({
  camera,
  deviceActive,
  fallbackName
}: CameraCellProps) => {
  return (
    <Stack gap={0}>
      <Group gap="xs" wrap="nowrap">
        <Image
          w={48}
          h={36}
          fit="cover"
          radius="sm"
          src={camera?.thumbnail || ImagePlaceholder}
          fallbackSrc={ImagePlaceholder}
          styles={(theme) => ({
            root: {
              outline: `1px solid ${theme.colors.dark[3]}`,
              flexShrink: 0
            }
          })}
        />
        <Group gap={6} wrap="nowrap">
          <Text size="xs" lineClamp={2}>
            {camera?.camera_name ?? fallbackName}
          </Text>
          {camera && (
            <OnlineStatus
              status={deviceActive && camera.connected ? 'online' : 'offline'}
              withText={false}
            />
          )}
        </Group>
      </Group>

      {camera?.error?.message && (
        <Group gap={4} wrap="nowrap" mt="xs">
          <IconAlertTriangle
            size={12}
            color="var(--mantine-color-red-6)"
            style={{ flexShrink: 0 }}
          />
          <Text size="xs" c="red">
            {camera.error.message}
          </Text>
        </Group>
      )}
    </Stack>
  )
}
